import * as Api from "./Api";

export default {
    index(payload) {
        return Api.client.get(`/producers`, payload);
    },
};
